import { render, staticRenderFns } from "./category-med.vue?vue&type=template&id=3c32dd1c&scoped=true"
import script from "./category-med.vue?vue&type=script&lang=js"
export * from "./category-med.vue?vue&type=script&lang=js"
import style0 from "./category-med.vue?vue&type=style&index=0&id=3c32dd1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c32dd1c",
  null
  
)

export default component.exports